module.exports = {
  ...require('./styles'),
  ...require('./inputs'),
};
